import { Dispatch, FC, SetStateAction } from "react";
import styles from "./Switch.module.css";

interface SwitchProps {
  label?: string;
  checked: boolean;
  setChecked?: Dispatch<SetStateAction<boolean>>;
  toggleChecked?: () => void;
  disabled?: boolean;
}

const Switch: FC<SwitchProps> = ({
  label,
  checked,
  setChecked,
  toggleChecked,
  disabled = false,
}) => {
  const handleChange = () => {
    if (disabled) return;
    if (setChecked) {
      setChecked((c) => !c);
    } else if (toggleChecked) {
      toggleChecked();
    }
  };

  return (
    <label className={`${styles.container} ${disabled ? styles.disabled : ""}`}>
      <div className={styles.switch}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
        />
        <span className={styles.slider}></span>
      </div>
      {label && <p>{label}</p>}
    </label>
  );
};

export default Switch;
